/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const authProviderSchema = z.object({
  domain: z.string().nullish(),
  id: z.string().uuid(),
  organizationId: z.string().uuid().nullish(),
  type: z.string().nullish(),
  url: z.string().nullish(),
});

export type AuthProvider = z.infer<typeof authProviderSchema>;
